import { ReactNode } from 'react';
import classNames from 'classnames';

import classes from './AsideLayout.module.scss';

type Props = {
  children: ReactNode;
};

type AsideProps = {
  children: ReactNode | (({ stickyClassName }: { stickyClassName: string }) => ReactNode);
};

type MainProps = Props & {
  withoutAside?: boolean;
};

const AsideLayoutTitle = ({ children }: Props) => <div className={classes.title}>{children}</div>;

const AsideLayoutContent = ({ children }: Props) => <div className={classes.content}>{children}</div>;

const AsideLayoutAside = ({ children }: AsideProps) => (
  <aside className={classes.aside}>
    {typeof children === 'function' ? children({ stickyClassName: classes.sticky }) : children}
  </aside>
);

const AsideLayout = ({ children, withoutAside }: MainProps) => (
  <div className={classNames({ [classes.layout]: !withoutAside, [classes.layoutWithoutAside]: withoutAside })}>
    {children}
  </div>
);

AsideLayout.Title = AsideLayoutTitle;
AsideLayout.Content = AsideLayoutContent;
AsideLayout.Aside = AsideLayoutAside;

export default AsideLayout;
